module.exports = "export default __webpack_public_path__ + &quot;c171c9afa64ae04ce6747261e7182089.svg&quot;;"